import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { IconsService } from '../services/icons.service';

@Component({
  selector: 'fcom-generic-icon',
  template: `
    <svg aria-hidden="true">
      <use [attr.xlink:href]="'#' + name" />
    </svg>
  `,
  styleUrls: ['./generic-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericIconComponent implements OnChanges {
  private _name: string;
  @Input()
  set name(name: string) {
    this._name = name;
  }
  get name(): string {
    return this._name || this.url;
  }

  @Input() url: string;

  constructor(private readonly iconService: IconsService) {}

  ngOnChanges(): void {
    this.addIcon();
  }

  private async addIcon(): Promise<void> {
    if (this.url) {
      await this.iconService.addIcon(this.name, this.url);
    }
  }
}
